import { PARTNERS } from './partners';

/**
 * Partners, whose offers can be solicited.
 * @type {Array}
 */
export const SOLICITATION_SUPPORTED_PARTNERS = [
  PARTNERS.CARMAX,
  PARTNERS.CASHFORCARS,
  PARTNERS.ECHOPARK,
  PARTNERS.ICO,
  PARTNERS.PLUG,
];
